// extracted by mini-css-extract-plugin
export default {"about":"About_about__oi9An","header":"About_header__4A9gx","content":"About_content__5DpMp"};